<div class="auth-container container-fluid min-vh-100">

  <!--<div class="position-fixed top-0 end-0 p-3 z-3">
    <app-theme-toggle-button></app-theme-toggle-button>
  </div>-->
  <div class="row min-vh-100">

    <!-- LEFT: LOGO / BRAND -->
    <div class="col-lg-6 d-none d-lg-flex justify-content-center align-items-center">
      <div class="text-center">
        <!-- Centered Light SVG Logo wrapped with routerLink -->
        <a
          routerLink="/"
          class="d-block mx-auto mb-3 text-decoration-none"
          style="max-width: 220px;"
          aria-label="KSNA Marketings Home"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="10 8 198 52"
            class="w-100 h-auto d-block"
          >
            <!-- Icon representing Home & Electronics -->
            <g transform="translate(10, 10)">
              <!-- House Outline -->
              <path d="M25 0 L50 20 L50 50 L0 50 L0 20 Z" fill="none" stroke="#ffffff" stroke-width="4" stroke-linejoin="round"/>
              <!-- Lightning Bolt -->
              <path d="M28 8 L14 28 L28 28 L20 44" fill="none" stroke="#0d6efd" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </g>

            <!-- Brand Text -->
            <g class="brand-text">
              <text x="75" y="36" font-family="system-ui, -apple-system, sans-serif" font-size="26" font-weight="800" fill="#ffffff">KSNA</text>
              <text x="76" y="54" font-family="system-ui, -apple-system, sans-serif" font-size="13" font-weight="600" fill="#ffffff" letter-spacing="3">MARKETINGS</text>
            </g>
          </svg>
        </a>

        <h4 class="fw-semibold text-white">{{ title }}</h4>
        <p class="text-white-50">{{ description }}</p>
      </div>
    </div>

    <!-- RIGHT: AUTH CONTENT -->
    <div class="col-12 col-lg-6 d-flex justify-content-center align-items-center">
      <div class="auth-card w-100">
        <router-outlet></router-outlet>
      </div>
    </div>

  </div>
</div>

